import axios from "axios";

export default {
  save(contactGroup) {
    var url = this.APIUrl + "/contact-group/";
    return axios.post(url, contactGroup);
  },
};
